// base in 1.7.7
// export this package's api
import Drawer from './Drawer';

export default Drawer;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-drawer/src/index.js
// module id = 801
// module chunks = 0